import React from 'react'

import style from './InfoModal.module.css'

import { BasicModal } from 'common/components'

type PropsType = {
  isShowInfo: boolean
  setIsShowInfo: (isShow: boolean) => void
}

export const InfoModal = ({ isShowInfo, setIsShowInfo }: PropsType) => {
  return (
    <BasicModal title="О приложении" isOpen={isShowInfo} onClose={() => setIsShowInfo(false)}>
      <div>
        <p className={style.text}>
          Перед вами первая версия дружелюбного приложения для обучения и подготовки к
          собеседованию.
        </p>
        <p className={style.text}>
          Вы можете принять участие в его развитии - стать авторов нового вопроса или теста,
          исправить ошибку. Инструкция для контрибьютеров находится на&nbsp;
          <a
            className={style.link}
            href="https://github.com/it-incubator/interview-questions-db"
            target="_blank"
            rel="noreferrer"
          >
            GitHub
          </a>
          .
        </p>
        <h3 className={style.title}>Немного о функционале</h3>
        <ul className={style['features-list']}>
          <li>Необходимо дать ответы на все вопросы теста</li>
          <li>
            Есть вопросы, которые допускают выбор единственного варианта ответа (радиокнопки) и
            многих вариантов (чекбоксы)
          </li>
          <li className={style['not-for-mobile-content']}>
            Можно использовать клавиатуру:
            <ul className={style['nested-list']}>
              <li> клавиши 1, 2, 3 и т.д. (выбор ответа)</li>
              <li> Enter (отправить ответ)</li>
              <li> Space (к следующему вопросу)</li>
              <li> стрелки ← → (переключение между вопросами)</li>
              <li> Esc (отменить тест)</li>
            </ul>
          </li>
          <li>
            Оценки тестов сохраняются в local storage. При очищении браузерного кеша, оценки
            сбросятся
          </li>
        </ul>
      </div>
    </BasicModal>
  )
}
